"use client"; // src/composite/utils.ts

import _createForOfIteratorHelper from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _toConsumableArray from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import { getDocument, isTextField } from "@ariakit/core/utils/dom";
var NULL_ITEM = {
  id: null
};

function flipItems(items, activeId) {
  var shouldInsertNullItem = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var index = items.findIndex(function (item) {
    return item.id === activeId;
  });
  return [].concat(_toConsumableArray(items.slice(index + 1)), _toConsumableArray(shouldInsertNullItem ? [NULL_ITEM] : []), _toConsumableArray(items.slice(0, index)));
}

function findFirstEnabledItem(items, excludeId) {
  return items.find(function (item) {
    if (excludeId) {
      return !item.disabled && item.id !== excludeId;
    }

    return !item.disabled;
  });
}

function getEnabledItem(store, id) {
  if (!id) return null;
  return store.item(id) || null;
}

function groupItemsByRows(items) {
  var rows = [];

  var _iterator = _createForOfIteratorHelper(items),
      _step;

  try {
    var _loop = function _loop() {
      var item = _step.value;
      var row = rows.find(function (currentRow) {
        var _a;

        return ((_a = currentRow[0]) == null ? void 0 : _a.rowId) === item.rowId;
      });

      if (row) {
        row.push(item);
      } else {
        rows.push([item]);
      }
    };

    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      _loop();
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return rows;
}

function selectTextField(element) {
  var collapseToEnd = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (isTextField(element)) {
    element.setSelectionRange(collapseToEnd ? element.value.length : 0, element.value.length);
  } else if (element.isContentEditable) {
    var selection = getDocument(element).getSelection();
    selection == null ? void 0 : selection.selectAllChildren(element);

    if (collapseToEnd) {
      selection == null ? void 0 : selection.collapseToEnd();
    }
  }
}

var FOCUS_SILENTLY = Symbol("FOCUS_SILENTLY");

function focusSilently(element) {
  element[FOCUS_SILENTLY] = true;
  element.focus({
    preventScroll: true
  });
}

function silentlyFocused(element) {
  var isSilentlyFocused = element[FOCUS_SILENTLY];
  delete element[FOCUS_SILENTLY];
  return isSilentlyFocused;
}

function isItem(store, element, exclude) {
  if (!element) return false;
  if (element === exclude) return false;
  var item = store.item(element.id);
  if (!item) return false;
  if (exclude && item.element === exclude) return false;
  return true;
}

export { flipItems, findFirstEnabledItem, getEnabledItem, groupItemsByRows, selectTextField, focusSilently, silentlyFocused, isItem };